import { Trans } from "@lingui/react/macro";
import { Flex, Stack, Title } from "@mantine/core";
import { createFileRoute, redirect } from "@tanstack/react-router";

import BookingsCalendar from "@/features/bookings/bookings-calendar";
import { getGetBookingsQueryOptions } from "@/shared/api/generated/booking";
import { getGetCategoriesOptionallyfilteredbylocationQueryOptions } from "@/shared/api/generated/categories";
import { getGetDepartmentsOptionallyfilteredbylocationQueryOptions } from "@/shared/api/generated/departments";

export const Route = createFileRoute(
  "/_app/(single-location)/museum/$museumId/calendar/",
)({
  component: Index,
  beforeLoad: ({ context }) => {
    const canReadBookings = context.ability.can("read", "Booking");

    if (!canReadBookings) {
      console.error("User does not have permission to read bookings");
      redirect({
        to: "/unauthorized",
        throw: true,
      });
    }
  },
  loader: async ({ context, params }) => {
    const [departmentsResult, bookingsResult, productCategoriesResult] =
      await Promise.allSettled([
        context.queryClient.ensureQueryData(
          getGetDepartmentsOptionallyfilteredbylocationQueryOptions({
            location: params.museumId,
          }),
        ),
        context.queryClient.ensureQueryData(
          getGetBookingsQueryOptions({
            locations: [params.museumId],
            includeProgram: true,
            includeCancelled: true,
          }),
        ),
        context.queryClient.ensureQueryData(
          getGetCategoriesOptionallyfilteredbylocationQueryOptions({
            location: params.museumId,
          }),
        ),
      ]);

    return {
      departments:
        departmentsResult.status === "fulfilled"
          ? departmentsResult.value?.data
          : null,
      bookings:
        bookingsResult.status === "fulfilled"
          ? bookingsResult.value?.data
          : null,
      productCategories:
        productCategoriesResult.status === "fulfilled"
          ? productCategoriesResult.value?.data
          : null,
    };
  },
});

function Index() {
  const { departments, bookings, productCategories } = Route.useLoaderData();

  return (
    <Stack p="lg" h="100%">
      <Flex align="center" justify="space-between">
        <Title order={1}>
          <Trans>Kalenderoversikt</Trans>
        </Title>
      </Flex>

      <BookingsCalendar
        departments={departments}
        bookings={bookings}
        productCategories={productCategories}
      />
    </Stack>
  );
}
